import * as Highcharts from "highcharts";
import {Options} from "highcharts";
import {default as init} from "surveylabJsAssets/chart/charts";
import {setDefaultOptions as sdbbSetDefaultOptions} from "sdbbJsAssets/chart/charts";

export function setDefaultOptions(options: Options) {
    const mergedOptions = Highcharts.merge({
        colors: ['#128400'],
    }, options);

    sdbbSetDefaultOptions(mergedOptions);
}

export default function () {
    setDefaultOptions({});
    init();
}